import { adminAreaQueryKeys as e } from "./adminAreaQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { adminAreaApi as r } from "@maat/api-main";
//#region src/areas/admin/useAddAttractionMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: ({ areaId: e, data: t }) => r.addAttraction(e, t),
		onSuccess: (t, { areaId: n }) => {
			i.invalidateQueries({ queryKey: e.attractions(n) }), i.invalidateQueries({ queryKey: e.list() });
		}
	});
};
//#endregion
export { i as useAddAttractionMutation };
